import Controller from "./stationsTimeline.controller";
import template from "./stationsTimeline.html";

const stationsTimeline = {
  template,
  controller: Controller,
  bindings: {
    ride: "<",
    schedules: "<",
    status: "<",
    arrivedEvent: "<",
    departedEvent: "<",
    realtimeEvent: "<",
    skipStationEvent: "<",
    connectionStatusEvent: "<",
  },
};

export default stationsTimeline;



// WEBPACK FOOTER //
// ./src/components/stationsTimeline/stationsTimeline.component.js